import { Module } from "vuex";
import { CommonState, PantryCameraImage, RootState } from "@/types/common";
import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

const state: CommonState = {
  isLoading: false,
  apiBaseParams: {
    token: null,
    apiKey: null,
    applianceId: null,
    appliance: null,
    applianceList: null,
    userAgent: null,
    termId: null
  },
  apiError: null,
  logId: null,
  searchAppliance: null,
  attachmentList: null,
  isFullscreenLoading: false,
  pantryCameraImage: null
};

export const common: Module<CommonState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
